<template>
  <div class="bigbox" >
      <img-app :style="backImg" :contactTitle="contact.name" :contactList="contact.contactlist" ></img-app>
      <div class="main">
          <div class="EachDetail" >
            <div class="mainTitle ft16 lh-100 fontWeight">
              站内招聘
            </div>
            
              <table class="table recruit_inner">
                <!-- <router-link v-for="item in recruit_inner" :to="item.to" class="block"> -->
                  <tr v-for="item in recruit_inner" @mouseenter="hover($event)" @mouseleave="leave($event)">
                    
                    <td width="7%">{{item.num}}</td>
                    <td class="recruit_inner-pro"><router-link :to="{path:item.to,params:{name:11111}}" class="block w-100" >{{item.profession}}</router-link></td>
                    <td width="30%" class="text-center">{{item.experience}}</td>
                    <td width="30%" class="text-center">{{item.address}}</td>
                    <td width="10%" class="text-right">{{item.total}}</td>
                   
                 </tr>
               <!-- </router-link>  -->
               <!-- <tr>
                  <td>1</td>
                  <td>IOS开发工程师</td>
                  <td>3年工作经验</td>
                  <td>浙江省·杭州市·江干区·水墩新路8号-5楼</td>
                  <td>1人</td>
               </tr>
               <tr>
                  <td>1</td>
                  <td>IOS开发工程师</td>
                  <td>3年工作经验</td>
                  <td>浙江省·杭州市·江干区·水墩新路8号-5楼</td>
                  <td>1人</td>
               </tr> -->
              </table>
            <pagination :total="total" :currentPage="current" @pagechange="pagechange" v-show="total>10"></pagination>
            <div class="text-center pt16 color545759 " v-show="total<=10">暂无更多</div>
          </div>
          <div class="EachDetail" >
            <div class="mainTitle ft16 lh-100 fontWeight">
              站外招聘
            </div>
            <div class="web_zhaopin ">
              <div class="web_zhaopin-item relative">
                <img src="static/images/web_zhaopin02.png" alt="">
                <a href="http://jobs.51job.com/all/co3796436.html" target="_blank" class="block w-100"><button class="absolute web_zhaopin-btn btn" @mouseenter="showZhezhao($event)" @mouseleave="hideZhezhao($event)">前程无忧</button></a>
                <div class="absolute zhezhao hide"></div>
              </div>
              <div class="web_zhaopin-item relative">
                <img src="static/images/web_zhaopin01.png" alt="">
                <a href="https://company.zhaopin.com/CZ191805110.htm" target="_blank">
                <button class="absolute web_zhaopin-btn btn"   @mouseenter="showZhezhao($event)" @mouseleave="hideZhezhao($event)">智联招聘</button></a>
                <div class="absolute zhezhao hide"></div>
              </div>
              
              <!-- <div class="web_zhaopin-item relative">
                <img src="static/images/web_zhaopin03.png" alt="">
                <button class="absolute web_zhaopin-btn btn">赶集网</button>
              </div>
              <div class="web_zhaopin-item relative">
                <img src="static/images/web_zhaopin04.png" alt="">
                <button class="absolute web_zhaopin-btn btn">58同城</button>
              </div> -->
            </div>
          </div>
          <div class="h68"></div>
      </div>
    </div>
</template>

<script>
 import imgApp from '@/components/common/imgApp.vue'; 
 import pagination from '@/components/common/pagination.vue'; 
 import bus from '@/assets/js/bus'
export default {
  name: 'talent_zhaopin',
  data () {
    return {
      backImg:{
        background:'url(static/images/recruit-bg.jpg) no-repeat',
				// background:'url(static/images/recruit-bg.jpg) no-repeat center 68px',
        backgroundSize:'cover'
      },
      contact:{
        name:'人才招聘',
        contactlist:[{listTitle:"站内招聘"},{listTitle:"站外招聘"}]
      },
      recruit_inner:[
        {
          to:'/recruit/1',
          num:1,
          profession:'销售顾问（销售软件系统）',
          experience:'0-3年工作经验',
          address:'浙江省·杭州市·江干区·水墩新路8号-5楼',
          total:'若干人'
        },
        {
          to:'/recruit/2',
          num:2,
          profession:'软件测试主管',
          experience:'3-5年工作经验',
          address:'浙江省·杭州市·江干区·水墩新路8号-5楼',
          total:'1人'
        },
        {
          to:'/recruit/3',
          num:3,
          profession:'产品专员/助理（负责管理类软件产品设计）',
          experience:'1-3年工作经验',
          address:'浙江省·杭州市·江干区·水墩新路8号-5楼',
          total:'若干人'
        },
        {
          to:'/recruit/4',
          num:4,
          profession:'EHS专业技术工程师（环保方向）',
          experience:'3-5年工作经验',
          address:'浙江省·杭州市·江干区·水墩新路8号-5楼',
          total:'1人'
        },
        {
          to:'/recruit/5',
          num:5,
          profession:'软件UI设计实习',
          experience:'0-1年工作经验',
          address:'浙江省·杭州市·江干区·水墩新路8号-5楼',
          total:'1人'
        },
        {
          to:'/recruit/6',
          num:6,
          profession:'客服专员',
          experience:'0-2年工作经验',
          address:'浙江省·杭州市·江干区·水墩新路8号-5楼',
          total:'若干人'
        },
        {
          to:'/recruit/7',
          num:7,
          profession:'数据分析工程师（实习）',
          experience:'0-1年工作经验',
          address:'浙江省·杭州市·江干区·水墩新路8号-5楼',
          total:'1人'
        },
        {
          to:'/recruit/8',
          num:8,
          profession:'Java开发工程师',
          experience:'2年工作经验',
          address:'浙江省·杭州市·江干区·水墩新路8号-5楼',
          total:'2人'
        },
        {
          to:'/recruit/9',
          num:9,
          profession:'高级JAVA开发工程师',
          experience:'3-5年工作经验',
          address:'浙江省·杭州市·江干区·水墩新路8号-5楼',
          total:'1人'
        },
        {
          to:'/recruit/10',
          num:10,
          profession:'Web前端开发工程师（H5+JS+CSS）',
          experience:'2年工作经验',
          address:'浙江省·杭州市·江干区·水墩新路8号-5楼',
          total:'1人'
        },
        
      ],
       total:9,//总条数
      display:10,//每页显示的条数
      current:1,//当前页数
    }
  },
  methods:{
    showZhezhao(event){
      var target=event.target;
      $(target).parent().siblings('.zhezhao').removeClass('hide');
      //$('.zhezhao').removeClass('hide');
    },
    hideZhezhao(event){
      var target=event.target;
      $(target).parent().siblings('.zhezhao').addClass('hide');
    },
    changeHash(index){

      var EachDetail=$('.EachDetail');
      //获取需要滚动的距离
      let scrollHeight=EachDetail[index].offsetTop-200;
      //console.log(scrollHeight)
      //console.log($(document).scrollTop())

      //chrome
      /*document.body.scrollTop=scrollHeight;
      //firefox
      document.documentElement.scrollTop=scrollHeight;
      //safari
      window.pageYOffset=scrollHeight;*/
      //获取当前滚动条与顶部的距离
      let distance=document.documentElement.scrollTop||document.body.scrollTop;

      //计算每一小段的距离
      let step=scrollHeight/50;
      //屏幕向上滚动，内容由下至上
      if(distance<scrollHeight){
          smoothDown()
      }
      //屏幕向下滚动，内容由上至下
      else{
        let scrollDistance=distance-scrollHeight;
        step=scrollDistance/50;
        smoothUp();
      }
      function smoothDown(){
        if(distance<scrollHeight){
          distance+=step
          document.body.scrollTop=distance;
          document.documentElement.scrollTop=distance;
          setTimeout(smoothDown,5)
        }
        else{
          // 限制滚动停止时的距离
          document.body.scrollTop = scrollHeight
          document.documentElement.scrollTop = scrollHeight
        }
      }
      function smoothUp(){
        if (distance > scrollHeight) {
            distance -= step;
            document.body.scrollTop = distance;
            document.documentElement.scrollTop = distance;
            setTimeout(smoothUp, 10);
        } else {
            document.body.scrollTop = scrollHeight
            document.documentElement.scrollTop = scrollHeight
        }
      }
   },
   pagechange(currentPage){//当点击时，当前页数传到后台，后台返回相应的页数的数据？
      console.log(currentPage)
   },
   onScroll(){
    let scrolled = document.documentElement.scrollTop || document.body.scrollTop
    var EachDetail=$('.EachDetail');
    var arr=[];
    var mainTop=$('.main').offset().top;
    for(var i=0;i<EachDetail.length;i++){
      var topScroll=$(EachDetail[i]).position().top;
      if(mainTop!=434){
        topScroll-=68;
      }
      arr.push(topScroll);
    }
    //showAcitve(arr.length)
    //console.log(arr)//502, 704, 906, 1224     434  636  838  1156
    //console.log(scrolled)
    //console.log(scrolled<=434,434<scrolled && scrolled<=636,636<scrolled && scrolled<=838)
    if(scrolled<=arr[0]){
        bus.$emit('navChange',0);  
    }else {
      bus.$emit('navChange',1);
    }
   },
   hover(event){
    //console.log(event.target)
    $(event.target).find($('.recruit_inner-pro')).css('color','#00aaff')
   },
   leave(event){
    $(event.target).find($('.recruit_inner-pro')).css('color','#18191a')
   }
  },
  components:{
    "img-app":imgApp,
    "pagination":pagination,
    
  },
  beforeCreate(){
    bus.$emit('NoshowAnimate',this.flase)
  },
  created(){
    bus.$on('navHash',(index)=>{
      this.changeHash(index);
    })
  },
  mounted: function () {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.onScroll)
    })
  },
   destroyed(){
      window.removeEventListener('scroll', this.onScroll);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  width: 1172px;
  margin:4px auto 0;
  padding-left: 200px;
  color:#18191a;
}
.main .mainTitle{
   margin-top: 74px;
   padding-bottom: 28px;
   padding-left: 16px;
   background: url(../../static/images/current_title.png) no-repeat 2px 4px;
   color:#18191a;
}
.recruit_inner{
  line-height: 38px;
  
  margin-bottom: 0;
}
.recruit_inner tr{
  vertical-align: top;
}
.recruit_inner tr:hover{
  cursor: pointer;
}


.recruit_inner tr:active{
  color:#84898c;cursor: pointer;
}
.recruit_inner-pro {overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.recruit_inner-pro a{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 230px;}

.web_zhaopin{
  display: flex;
}
.web_zhaopin img{
  margin-right: 97px;
}

.web_zhaopin-item button{
  top:30px;
  margin-left:50%;
  left:-104px;
}

.web_zhaopin-btn{
  width: 112px;
  height: 46px;
  background-color: #094d6e;
  color:#fff;
  border-radius: 8px;
  opacity: 0.86;
  outline: none;
  z-index: 1;
}

.web_zhaopin-btn:hover{
  background-color: #00aaff;
  opacity:1;

}
.web_zhaopin-btn:active{
  outline: none;
}
.zhezhao{
  background-color: rgba(0,0,0,0.5);
  top:0;
  width: 170px;
  height: 100%;
}
@media (max-width: 1240px){
  .main{
      width: 100%;
      padding-left:24%;
      padding-right: 6%;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/talent_zhaopin.vue